import { Box } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from '../../../../../theme/components/TableHeader/TableHeader';
import { BeneficiosMGMParametrosHeader } from './BeneficiosMGMParametrosHeader';
import { BeneficiosMGMParametrosFilters } from './BeneficiosMGMParametrosFilters';
import { BeneficiosMGMResumo } from './BeneficiosMGMResumo';

export const BeneficiosMGMParametros = props => {
  const { filters, setFilters, setSelectedFilter, grantedCount } = props;

  return (
    <Box mb={2}>
      <BeneficiosMGMResumo grantedCount={grantedCount} />
      <TableHeader>
        <BeneficiosMGMParametrosHeader filters={filters} setFilters={setFilters} />
        <BeneficiosMGMParametrosFilters
          filters={filters}
          setFilters={setFilters}
          setSelectedFilter={setSelectedFilter}
        />
      </TableHeader>
    </Box>
  );
};

BeneficiosMGMParametros.propTypes = {
  filters: PropTypes.shape({
    indicatedOrigin: PropTypes.string,
    indicatedPaymentStatus: PropTypes.string,
    indicatorPaymentStatus: PropTypes.string,
    endPeriod: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  setSelectedFilter: PropTypes.func.isRequired,
};
